import { render, staticRenderFns } from "./merchant_profile.vue?vue&type=template&id=482ea2f8&scoped=true"
import script from "./merchant_profile.vue?vue&type=script&lang=js"
export * from "./merchant_profile.vue?vue&type=script&lang=js"
import style0 from "./merchant_profile.vue?vue&type=style&index=0&id=482ea2f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ea2f8",
  null
  
)

export default component.exports